export const getArtefatos = (state) => state.artefatos;
